/**
 * Welcher Navigationspunkt zum aktuellen Pfad gehört (§20.1).
 *
 * Die eingebaute Markierung von `NavLink` reicht hier nicht: „Abstimmungen" führt über
 * {@link AbstimmungenWeiche} auf `/verwaltung/veranstaltungen/:id/abstimmungen` — Abstimmungen
 * gehören immer zu einer Veranstaltung (§10.2). Nach dem Sprung passte der Pfad auf den Punkt
 * „Veranstaltungen", und die Markierung sprang beim Klick sichtbar zurück.
 *
 * Deshalb entscheidet der **fachliche** Bereich und nicht die Pfadform: Alles, was Abstimmungen
 * betrifft, gehört zu „Abstimmungen" — gleich unter welcher Veranstaltung es liegt.
 */

const WURZEL = '/verwaltung';

/** Ob der Navigationspunkt `pfad` zum Ort `pathname` gehört. */
export function istBereichAktiv(pfad: string, pathname: string): boolean {
  return bereichVon(pathname) === pfad;
}

/**
 * Der Navigationspunkt, zu dem ein Pfad gehört — oder `undefined` außerhalb der Bereiche.
 *
 * Genau ein Punkt ist markiert: Die Zuordnung ist eindeutig, weil sie einen einzigen Wert
 * liefert. Zwei gleichzeitig markierte Punkte kann es dadurch nicht geben.
 */
export function bereichVon(pathname: string): string | undefined {
  if (!pathname.startsWith(`${WURZEL}/`)) {
    return undefined;
  }

  const teile = pathname.slice(WURZEL.length + 1).split('/');
  const erster = teile[0];

  // `/verwaltung/veranstaltungen/:id/abstimmungen…` gehört fachlich zu den Abstimmungen.
  if (erster === 'veranstaltungen' && teile[2] === 'abstimmungen') {
    return 'abstimmungen';
  }

  return erster === '' ? undefined : erster;
}
